import { apiClient } from "../api/httpClient";

export const createSupportRequest = async (payload) => {
  // payload: { bond_type, name, request_body (json string), user_comment }
  return apiClient("support-requests/create/", "POST", payload);
};

export const listSupportRequests = async () => {
  return apiClient("support-requests/list/", "GET");
};

export const resumeSupportRequest = async (id) => {
  return apiClient(`support-requests/${id}/resume/`, "GET");
};

export const updateSupportRequest = async (id, payload) => {
  // payload: { internal_comment }
  return apiClient(`support-requests/${id}/complete/`, "PATCH", payload);
};

export const deleteSupportRequest = async (id) => {
  return apiClient(`support-requests/${id}/delete/`, "DELETE");
};
